import { requestApi } from 'api/api'

export const getChatbotAuthToken = async ({ signal }: { signal?: AbortSignal }) => {
  return requestApi({
    url: '/accounts-management/v1/support/chat/login',
    method: 'POST',
    config: {
      ...(signal && {
        signal,
      }),
    },
  })
}
